"use strict";
// Type definitions for Venue system based on Prisma schema
Object.defineProperty(exports, "__esModule", { value: true });
exports.DAY_OF_WEEK_SHORT = exports.DAY_OF_WEEK_LABELS = exports.CHANNEL_COLORS = exports.CHANNEL_LABELS = exports.BOOKING_COLORS = void 0;
// Booking colors helper
exports.BOOKING_COLORS = {
    ONLINE: '#00E676',
    FIXED: '#42A5F5',
    MANUAL: '#AB47BC',
    CANCELLED: '#FF5252', // Red
};
// Booking channel labels and colors
exports.CHANNEL_LABELS = {
    WHATSAPP: 'WhatsApp',
    PHONE: 'Teléfono',
    WALKIN: 'Walk-in',
    INSTAGRAM: 'Instagram',
    WEB: 'Web',
    OTHER: 'Otro',
};
exports.CHANNEL_COLORS = {
    WHATSAPP: '#25D366',
    PHONE: '#FF9800',
    WALKIN: '#9C27B0',
    INSTAGRAM: '#E4405F',
    WEB: '#2196F3',
    OTHER: '#757575',
};
// Day of week helper
exports.DAY_OF_WEEK_LABELS = [
    'Domingo',
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
];
exports.DAY_OF_WEEK_SHORT = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
